import { useState } from "react";
import { usePatientSurgeryStore } from "../../hooks";
import { InputForm as Input } from "../../ui";

export const PatientInfoCard = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    patientSurgery,
  } = usePatientSurgeryStore();

  const { patient } = patientSurgery.data;

  // States ------------------------------------------------//
  const { activeIndex, setActiveIndex } = useState(1);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <div className="w-full">
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <a className="nav-link active" aria-current="page">
            General
          </a>
        </li>
      </ul>
      <div className="card">
        <div className="card-body">
          <div className="row gy-4">
            {patient.user.firstName && (
              <div className="col-12 col-md-6 col-xl-4 col-xxl-3">
                <Input
                  label="Nombres"
                  type="text"
                  name="patientName"
                  value={patient.user.firstName}
                  onInputChange={() => {}}
                  disabled={true}
                />
              </div>
            )}
            {patient.user.lastName && (
              <div className="col-12 col-md-6 col-xl-4 col-xxl-3">
                <Input
                  label="Apellidos"
                  type="text"
                  name="patientLastName"
                  value={patient.user.lastName}
                  onInputChange={() => {}}
                  disabled={true}
                />
              </div>
            )}
            {patient.user.document && (
              <div className="col-12 col-md-6 col-xl-4 col-xxl-3">
                <Input
                  label="Identificacion"
                  type="text"
                  name="patientDocument"
                  value={patient.user.document}
                  onInputChange={() => {}}
                  disabled={true}
                />
              </div>
            )}
            {patient.user.email && (
              <div className="col-12 col-md-6 col-xl-4 col-xxl-3">
                <Input
                  label="Correo electrónico"
                  type="text"
                  name="patientEmail"
                  value={patient.user.email}
                  onInputChange={() => {}}
                  disabled={true}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
